import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";
import GlobalPlayer from "./components/GlobalPlayer";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Studio from "./pages/Studio";
import About from "./pages/About";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/about" element={<About />} />
            </Routes>
            <GlobalPlayer />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
        </PlayerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
